import { HydrateWidgetFn } from '@framework/engine';
import { get } from 'lodash';
import { ICompetenceWidget } from './ICompetenceWidget';
import { competenceSelectWidgetLabelName } from './createCompetenceSelectFormSchema';

/**
 * L'idratazione del campo competenza non ritorna il suo ID ma la sua
 * descrizione (label) salvata in un campo interna apposito.
 */
export const hydrateCompetenceWidget: HydrateWidgetFn<ICompetenceWidget> = ({
  context,
  path,
}) => {
  const value = get(context.values, competenceSelectWidgetLabelName(path));

  return {
    // Se il valore è undefined, non sovrascrivo il valore precedente
    value: value ?? undefined,
  };
};
